// SETTINGS V2 — reusable confirm dialog (SETTINGS_V2_SP3 §7.5).
//
// Replaces the RENDERER of the legacy shared MUI ConfirmationProvider
// (useConfirmation) with a thin consumer of SettingsV2DialogShell — same keys,
// same handler semantics. SP3 wires it as the delete-contact confirm; SP4
// (disable location) + SP6 (delete user) reuse it (same-scope split precedent
// as SP2's DialogShell). Caller passes already-translated strings — this dialog
// never translates. Inline styles + scoped CSS-var tokens; no MUI/sx/dt/Tailwind.
// SEC-REQ-2: no import-time side effects.
import React from "react";

import SettingsV2DialogShell from "./SettingsV2DialogShell";

export interface SettingsV2ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  title: string; // settings:deleteContact
  text: string; // settings:deleteContactText with {{name}} interpolation
  confirmLabel: string; // settings:deleteContactConfirm
  cancelLabel: string; // settings:deleteContactCancel
  danger?: boolean; // true → confirm button background var(--red)
  onConfirm: () => void;
}

const SettingsV2ConfirmDialog: React.FC<SettingsV2ConfirmDialogProps> = ({
  open,
  onClose,
  title,
  text,
  confirmLabel,
  cancelLabel,
  danger,
  onConfirm,
}) => {
  const footer = (
    <>
      <button type="button" className="btn btn-ghost" onClick={onClose}>
        {cancelLabel}
      </button>
      <button
        type="button"
        className="btn btn-primary"
        onClick={onConfirm}
        style={
          danger
            ? { background: "var(--red)", borderColor: "var(--red)" }
            : undefined
        }
      >
        {confirmLabel}
      </button>
    </>
  );

  return (
    <SettingsV2DialogShell
      open={open}
      onClose={onClose}
      width={440}
      title={title}
      labelledById="sv2-confirm-title"
      footer={footer}
    >
      <p
        style={{
          fontSize: 13,
          color: "var(--ink-2)",
          lineHeight: 1.6,
          margin: 0,
        }}
      >
        {text}
      </p>
    </SettingsV2DialogShell>
  );
};

export default SettingsV2ConfirmDialog;
